import { Platform } from 'react-native';

/** Calendario inline en iOS 14+; rueda en versiones anteriores */
export const iosDatePickerDisplay = (): 'inline' | 'spinner' => {
  if (Platform.OS !== 'ios') return 'spinner';
  const v = Platform.Version;
  const major = typeof v === 'string' ? parseInt(v.split('.')[0] ?? '0', 10) : v;
  return !Number.isNaN(major) && major >= 14 ? 'inline' : 'spinner';
};
